<template>
  <router-view />
</template>

<script>
export default {
    name: 'ExLayout'
}
</script>

<style scoped>

</style>